class ThemeInformationTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-information-tab]')];
    this.panels = [...this.querySelectorAll('[data-information-panel]')];
    if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
    this.listeners = new AbortController();
    const options = { signal: this.listeners.signal };
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.activate(tab.dataset.informationTab), options);
      tab.addEventListener('keydown', event => this.handleKeydown(event), options);
    });
    const selected = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
    this.activate(selected.dataset.informationTab, false, false);
  }

  disconnectedCallback() {
    this.listeners?.abort();
  }

  activate(name, moveFocus = false, reveal = true) {
    const selected = this.tabs.find(tab => tab.dataset.informationTab === name);
    if (!selected) return;
    this.tabs.forEach(tab => {
      const active = tab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach(panel => {
      const active = panel.dataset.informationPanel === name;
      panel.hidden = !active;
      panel.inert = !active;
      panel.setAttribute('aria-hidden', String(!active));
    });
    if (moveFocus) selected.focus({ preventScroll: true });
    if (reveal) this.reveal(selected);
  }

  reveal(selected) {
    const strip = this.querySelector('.theme-information-tabs-list');
    if (!strip || strip.scrollWidth <= strip.clientWidth) return;
    const stripRect = strip.getBoundingClientRect();
    const selectedRect = selected.getBoundingClientRect();
    if (selectedRect.left < stripRect.left) strip.scrollLeft += selectedRect.left - stripRect.left;
    else if (selectedRect.right > stripRect.right) strip.scrollLeft += selectedRect.right - stripRect.right;
  }

  handleKeydown(event) {
    const current = this.tabs.indexOf(event.currentTarget);
    if (current < 0) return;
    let next;
    if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = this.tabs.length - 1;
    else return;
    event.preventDefault();
    this.activate(this.tabs[next].dataset.informationTab, true);
  }
}
customElements.define('fl-information-tabs', ThemeInformationTabs);
